<template>
    <Header></Header>
    <div class="container sub_page _news">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_02"><img src="img/news_left.png" /></i>
                <i class="deco_03 _xsmall spin3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom1"><img src="img/b_icon_04.png" /></i>
                <i class="deco_05 _xxxsmall blink_blink1"><img src="img/b_icon_04.png" /></i>
                <i class="deco_06"><img src="img/line_circle.png" /></i>
                <i class="deco_07 _small spin_blink2"><img src="img/b_icon_01.png" /></i>
                <i class="deco_08 _xsmall blink_blink3"><img src="img/b_icon_04.png" /></i>
                <i class="deco_09 _xsmall blink2"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/news_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>감시소식</h2>
            </div>
        </section>

        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="감시소식" /></span>
                <router-link to="/news">감시소식</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="반성매매 시민활동" /></span>
                <a href="javascript:void(0)" style="cursor: default">{{ state.data.title }}</a>
                <!-- <span class="news_title">{{ state.data.title }}</span> -->
            </div>
            <div class="sub_page_con_view con_view">
                <div class="tit_wrap flex_wrap">
                    <span class="con_tit">{{ state.data.title }}</span>
                    <div class="con_tit_info">
                        <span class="">{{ CommonUtils.dateFormat(new Date(state.data.createDate), ".", true) }}</span>
                        <span class="">
                            <span><img src="img/view.png" alt="" /></span>
                            {{ state.data.viewCnt }}
                        </span>
                    </div>
                </div>

                <div class="">
                    <div class="content" v-html="CommonUtils.decodeContent(state.data.content)"></div>
                    <div class="apply_wrap btn_wrap _default _center" v-if="!state.hasAuth">
                        <button class="common_btn _gray w_130" @click="router.push('/news')">목록</button>
                    </div>
                    <!--관리자 버튼-->
                    <div class="apply_wrap btn_wrap _default right_btn" v-if="state.hasAuth">
                        <button class="common_btn _gray" type="button" @click="confirmRemove">삭제</button>
                        <button class="common_btn" type="button" @click="router.push({ name: 'NewsModify', params: { id: state.idx } })">수정</button>
                        <button class="common_btn" type="button" @click="router.push('/news')">목록</button>
                    </div>
                    <!--관리자 버튼-->
                </div>
            </div>
            <div class="list_wrap">
                <router-link v-if="state.data.next" :to="{ name: 'NewsView', params: { id: state.data.next.idx } }" class="next_list">
                    <span>다음글</span>
                    <div class="list_tit elips_1">
                        {{ state.data.next.title }}
                    </div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.next.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.next.createDate), ".", true) }}</div>
                </router-link>

                <router-link v-if="state.data.prev" :to="{ name: 'NewsView', params: { id: state.data.prev.idx } }" class="prev_list">
                    <span>이전글</span>
                    <div class="list_tit elips_1">{{ state.data.prev.title }}</div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.prev.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.prev.createDate), ".", true) }}</div>
                </router-link>
            </div>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>
<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        Header,
        Footer,
        useRoute,
        userStore,
        onBeforeMount,
        ModalDefault,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, Header, Footer, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();
            const state = reactive({
                idx: 0 as number,
                data: {} as types.ResBoardVOForApi,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false as boolean,

                isMobile: false,
            });

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(() => {
                const idx = Number(route.params.id);

                if (idx && typeof idx === "number" && !isNaN(idx)) {
                    state.idx = idx;
                    getDetail();
                } else {
                    router.back();
                }

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            watch(
                () => [user.userInfo, user.accessToken],
                () => {
                    hasAuth();
                    getDetail();
                },
            );

            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("news") > -1)))
                )
                    state.hasAuth = true;
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (state.modalTab === 8) router.back();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    removeData();
                } else if (param.action === "callback") {
                    state.isShowModal = false;
                    router.replace({ path: "/login", query: { redirect: "/newsView/" + state.idx } });
                } else if (param.action === "back") {
                    state.isShowModal = false;
                    router.back();
                }
            };

            const getDetail = async () => {
                const res = await apiService.boardNews.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const removeData = async () => {
                const res = await apiService.boardNews.remove(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.isShowModal = true;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmRemove = () => {
                if (user.isLogin()) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };
            return { state, router, CommonUtils, confirmRemove, closeModal, callBackModal };
        },
    };
</script>

<style scoped>
    .news_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }
</style>
